import { render, staticRenderFns } from "./gdprSetting.vue?vue&type=template&id=991dd2b6&scoped=true&"
import script from "./gdprSetting.vue?vue&type=script&lang=js&"
export * from "./gdprSetting.vue?vue&type=script&lang=js&"
import style0 from "./gdprSetting.vue?vue&type=style&index=0&id=991dd2b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991dd2b6",
  null
  
)

export default component.exports